var React = require('react');

function Docs (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"3.3","y1":"4","x2":"11.4","y2":"4","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"3.3","y1":"8","x2":"8.1","y2":"8","key":1}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"3.3","y1":"12","x2":"6.8","y2":"12","key":2}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t13.5,0.8 0.9,0.8 0.9,15.2 \t","key":3}),React.createElement("polygon",{"fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t15.1,8 8,8 8,15.2 \t","key":4})]));
}

Docs.displayName = "Docs";

Docs.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Docs;

Docs.default = Docs;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/docs.svg
// module id = ../icon/src/icons/docs.svg
// module chunks = 0